import {ContactInformationAttributes} from '@treez/commons/sharedTypings/directory';
import {PriceTierWithHasProductsFlag} from '@treez/commons/sharedTypings/priceTier';
import {OwnerType} from '@treez/commons/sharedTypings/product';
import {OrganizationState} from '~/redux/reducers/OrganizationReducer';
import {GlobalApplicationState} from '~/redux/reducers/RootReducer';
import {StoreAttributes} from '~/lib/directory';

export const selectOrganizationState = ({
    organizationState,
}: GlobalApplicationState): OrganizationState => organizationState;

export const selectOrganizationContactInformation = ({
    organizationState,
}: GlobalApplicationState): ContactInformationAttributes[] | undefined =>
    organizationState.contactInformation;

export const selectOrganizationCatalogId = ({organizationState}: GlobalApplicationState): number =>
    organizationState.organizationCatalogId;

export const selectOrganizationId = ({organizationState}: GlobalApplicationState): number =>
    organizationState.organizationId;

export const selectOrganizationName = ({organizationState}: GlobalApplicationState): string =>
    organizationState.organizationName;

export const selectStoresInOrganization = ({
    organizationState,
}: GlobalApplicationState): StoreAttributes[] | undefined => organizationState.stores;

export const selectStoreRegionByCatalogId = (
    {organizationState}: GlobalApplicationState,
    catalogId: number
): string | undefined => {
    const store = (organizationState.stores || []).find((store) => store.catalogId === catalogId);

    if (store) {
        const contactInformation = (store.contactInformation || []).find((info) => info.primary);

        return contactInformation?.state;
    }
};

export const selectPriceTiersForOrganization = ({
    organizationState,
}: GlobalApplicationState): PriceTierWithHasProductsFlag[] | undefined =>
    organizationState.priceTiers;

export const selectOrganizationPriceTiersForSelection = ({
    organizationState,
}: GlobalApplicationState): PriceTierWithHasProductsFlag[] | undefined =>
    organizationState.priceTiers?.filter(
        (tier) => tier.isActive && tier.ownerType === OwnerType.ORG
    );
